import React from 'react'

const Description = ({ html }) => {
  if (!html) {
    return null
  }
  return (
    <p
      className="m-0 text-12 lg:text-16"
      dangerouslySetInnerHTML={{
        __html: html.replace(/<p>/g, '<p class="mb-0">')
      }}
    />
  )
}

export default Description
